export function transformHafasLocationResponse({stations}: DbiApi.HafasLocationResponse): Dbi.Station[] {
    return (stations || []).map(transformHafasLocation)
}

export function transformHafasLocation({id, name, extId, type, products}: DbiApi.HafasLocation): Dbi.Station {
    return {name, eva: parseInt(extId).toString(), hafasId: id, type, products}
}
